'use strict';

var cov_1jasfoxau = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/contenteditable.directive.js',
        hash = '9a6e49014a37b3cd52bbd06a1d930efa97c201a4',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/contenteditable.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 20
                },
                end: {
                    line: 11,
                    column: 58
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 18
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 59
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 46
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: 'read',
                decl: {
                    start: {
                        line: 10,
                        column: 25
                    },
                    end: {
                        line: 10,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 17
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 34
                    },
                    end: {
                        line: 14,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 46
                    },
                    end: {
                        line: 16,
                        column: 17
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 50
                    },
                    end: {
                        line: 18,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 62
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                },
                line: 18
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 33
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 15,
                        column: 33
                    },
                    end: {
                        line: 15,
                        column: 51
                    }
                }, {
                    start: {
                        line: 15,
                        column: 55
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1jasfoxau.s[0]++;
(function () {
    'use strict';

    cov_1jasfoxau.f[0]++;
    cov_1jasfoxau.s[1]++;
    angular.module('app').directive("contenteditable", function () {
        cov_1jasfoxau.f[1]++;
        cov_1jasfoxau.s[2]++;

        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attrs, ngModel) {
                function read() {
                    cov_1jasfoxau.f[2]++;
                    cov_1jasfoxau.s[3]++;

                    ngModel.$setViewValue(element.html());
                }

                cov_1jasfoxau.s[4]++;
                ngModel.$render = function () {
                    cov_1jasfoxau.f[3]++;
                    cov_1jasfoxau.s[5]++;

                    element.html((cov_1jasfoxau.b[0][0]++, ngModel.$viewValue) || (cov_1jasfoxau.b[0][1]++, ""));
                };

                cov_1jasfoxau.s[6]++;
                element.bind("blur keyup change", function () {
                    cov_1jasfoxau.f[4]++;
                    cov_1jasfoxau.s[7]++;

                    scope.$apply(read);
                });
            }
        };
    });
})();